import { cva } from 'class-variance-authority'
import { Slot } from 'radix-ui'
import { cn } from '@/lib/utils'
const badgeVariants = cva(
  'h-4 gap-1 rounded-lg border border-transparent px-2 py-0.5 text-xs font-medium has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&>svg]:size-3! inline-flex items-center justify-center w-fit whitespace-nowrap shrink-0 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive overflow-hidden group/badge relative',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground',
        secondary: 'bg-secondary text-secondary-foreground',
        destructive:
          'bg-destructive/10 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 text-destructive dark:bg-destructive/20',
        outline: 'border-border/40 text-foreground bg-input/30',
        ghost: '',
        link: 'text-primary underline-offset-4 hover:underline',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)
function Badge({ className, variant = 'default', asChild = false, children, ...props }) {
  const Comp = asChild ? Slot.Root : 'span'
  return (
    <Comp
      data-slot="badge"
      data-variant={variant}
      className={cn(
        badgeVariants({
          variant,
        }),
        className,
      )}
      {...props}
    >
      <span className="relative z-10 flex items-center justify-center gap-1">{children}</span>
      {variant !== 'link' && (
        <span className="absolute inset-0 bg-current opacity-0 group-hover/badge:opacity-[0.08] transition-opacity duration-150 pointer-events-none" />
      )}
    </Comp>
  )
}
export { Badge }
